import gl_ES from './nl_NL.json';
import en_GB from './en_GB.json';

const messages = {
  'nl-NL': gl_ES,
  'en-GB': en_GB,
};

export default messages;
